import * as React from 'react';
import * as styles from './styles.css';

import { InlineText1 } from '@cian/ui-kit';

export interface IRateOurEstimationThanksProps {
  isDesktop: boolean;
}

export const RateOurEstimationThanks: React.FC<IRateOurEstimationThanksProps> = ({ isDesktop }) => {
  return (
    <div data-testid="RateOurEstimationThanks" className={styles['container']}>
      <InlineText1>{isDesktop ? 'Спасибо за отзыв! Ваше мнение важно для нас' : 'Спасибо за отзыв!'}</InlineText1>
    </div>
  );
};

RateOurEstimationThanks.displayName = 'RateOurEstimationThanks';
